import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle, XCircle, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

import { BACKEND_URL } from '../config/api';

export default function VerifyEmail() {
  const { token } = useParams();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/auth/verify-email/${token}`);
        setStatus('success');
        setMessage(data.message);
        await checkAuth();
      } catch (err) {
        const code = err.response?.status;
        if (code === 410) {
          setStatus('expired');
          setMessage('This verification link has expired. Please request a new one.');
        } else {
          setStatus('invalid');
          setMessage('This verification link is invalid.');
        }
      }
    };
    verify();
  }, [token, checkAuth]);

  const icon = {
    loading: <Loader2 className="w-12 h-12 animate-spin text-[#4B6651]" />,
    success: <CheckCircle className="w-12 h-12 text-[#4B6651]" />,
    expired: <Clock className="w-12 h-12 text-[#C06144]" />,
    invalid: <XCircle className="w-12 h-12 text-[#D94F4F]" />,
  }[status];

  return (
    <div className="min-h-screen bg-[#F8F7F4] flex items-center justify-center p-4" data-testid="verify-email-page">
      <div className="bg-white rounded-xl shadow-sm border border-[#E5E4E0] p-8 max-w-md w-full text-center space-y-4">
        {icon}
        {status === 'loading' ? (
          <p className="text-[#5C5F5C]">Verifying your email...</p>
        ) : (
          <>
            <h2 className="text-xl font-semibold text-[#2A2C2A]">
              {status === 'success' ? 'Email Verified!' : status === 'expired' ? 'Link Expired' : 'Invalid Link'}
            </h2>
            <p className="text-[#5C5F5C]">{message}</p>
            <div className="pt-2">
              {status === 'success' ? (
                <Link to="/dashboard">
                  <Button className="bg-[#4B6651] hover:bg-[#3E5543] text-white" data-testid="go-dashboard-btn">
                    Go to Dashboard
                  </Button>
                </Link>
              ) : (
                <Link to="/login">
                  <Button variant="outline" className="border-[#E5E4E0]" data-testid="go-login-btn">
                    Back to Login
                  </Button>
                </Link>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
